import React, { createContext, useContext, useMemo, useState } from "react";

const ContentContext = createContext(null);

// 2. Create custom hook
export const useContentContext = () => {
    const context = useContext(ContentContext);
  
    if (!context) {
      throw new Error("useContentContext must be used within an ContentProvider");
    }
    return context;
};

export const ContentProvider = (props) => {
    const [actualPage, setActualPage] = useState("videowall");
    const [currentSideBar, setCurrentSideBar] = useState([]);

    const changePage = (page) => {
        setActualPage(page);
    }

    const changeSidebar = (sidebarMenus) => {
        setCurrentSideBar(sidebarMenus);
    }

    const value = useMemo(() => {
        return {
            actualPage,
            changePage,
            currentSideBar,
            changeSidebar
        };
    }, [actualPage, currentSideBar]);

    return <ContentContext.Provider value={value}>{props.children}</ContentContext.Provider>
};